import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { IGameState } from '../Game/IGameState';
import { SeasonPassActions } from './SeasonPassActions';
import { checkSeasonPassUnlocked, claimRankReward, increaseSeasonPassProgress, resetSeasonPass, setSeasonPassLastSeenProgress, setSeasonPassProgress } from 'State/Player/PlayerSeasonPassHelper';

export const SeasonPassReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof SeasonPassActions>
): IGameState => {
    switch (action.type) {
        case getType(SeasonPassActions.claimRankReward):
            state = claimRankReward(state, action.payload);
            break;
        case getType(SeasonPassActions.addSeasonPassProgress):
            state = {
                ...state,
                playerState: increaseSeasonPassProgress(state.playerState, action.payload)
            }
            break;
        case getType(SeasonPassActions.setSeasonPassProgress):
            state = {
                ...state,
                playerState: setSeasonPassProgress(state.playerState, action.payload)
            }
            break;
        case getType(SeasonPassActions.setSeasonPassLastSeenProgress):
            state = {
                ...state,
                playerState: setSeasonPassLastSeenProgress(state.playerState, action.payload)
            }
            break;
        case getType(SeasonPassActions.resetSeasonPass):
            state = resetSeasonPass(state);
            break;
        case getType(SeasonPassActions.checkSeasonPassUnlocked):
            state = checkSeasonPassUnlocked(state);
            break;
    }
    return state;
};
